import { FC } from 'react';
import { Box, Svg, Text } from '@hopskipdrive/react-components';

import { colorTokens } from '../../../../../shared/components/variables';

interface ContentHeadingProps {
  icon: string;
  headingTitle: string;
}

export const ContentHeading: FC<ContentHeadingProps> = ({ icon, headingTitle }) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap="12px">
      <Svg icon={icon} style={{ color: colorTokens.primary.main }} />
      <Text variant="h6" style={{ color: colorTokens.primary.main }}>
        {headingTitle}
      </Text>
    </Box>
  );
};
